<div id='FilePreviewDiv'>
    <ngx-smart-modal #FilePreviewModal
        class="file-preview-modal"
        [identifier]="modalType"
        [title]="modalTitle"
        [closable]="closable"
        [showCloseButton]="showCloseButton" 
        [closeButtonText]="closeButtonText"
        [disableConfirmButton]="disableConfirmButton"
        [confirmButtonText]="confirmButtonText">

        <app-file-preview
        [apiBaseUrl]="apiBaseUrl"
        [requestedFile]="file"
        [isPreviewableTextFile]="isPreviewableTextFile"
        (data)="dataChanged($event)"
        >
        </app-file-preview>

        <div *ngIf="isFolderLinkEnabled" class="file-preview-modal__folder-link-container">
            <rad-link 
            class="file-preview-modal__folder-link"
            [attr.href]="fileContainerPath" 
            target="_blank"
            [attr.external]="true"
            >View in folder</rad-link>
        </div>

    </ngx-smart-modal>
</div>
